import type { DrillSequence } from "@acepoker/contract";

export function getMovesFromSequence(sequence: DrillSequence["sequence"]) {
  return sequence
    .filter((el) => el.kind === "action")
    .map((el) => ({
      ...el.actions[el.selected],
      position: el.position,
      pot: el.pot,
    }));
}
